import React from 'react';
import 'animate.css';
import { cssTransition, Slide, ToastContainer } from 'react-toastify';

interface PropsType {}

const Toast: React.FC<PropsType> = () => {
  const Fade = cssTransition({
    // zoomIn will become zoomIn--top-right or zoomIn--top-left and so on
    enter: 'animate__animated animate__fadeIn animate__faster',
    // zoomIn will become zoomOut--top-right or zoomOut--top-left and so on
    exit: 'animate__animated animate__fadeOut animate__faster ',
  });
  return (
    <>
      <ToastContainer
        className='toast-position'
        position='top-right'
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        limit={3}
        pauseOnHover
        theme='light'
        transition={Fade}
      />
    </>
  );
};

export default Toast;
